export default {
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        alignItems: 'flex-start'
      },
      label: {
        marginTop: '4px',
        '&.Mui-disabled': {
          color: '#424242'
        }
      }
    }
  }
};
